import debug from 'debug'
import makeRab from 'state/location'
import store from 'state/store'
import 'css/app.scss'

const {dispatch} = store

const PROD = (process.env.NODE_ENV === "production")

import {apiCallReal} from 'state/actions/api'

// ease debugging
window.myDebug = debug
window.store = store
window.actions = require('state/actions')
console.warn('Run `myDebug.enable("*,-sockjs-client:*")` to see debug messages')

if (PROD) {
	window.onerror = (message, source, lineno, colno, error) => {
		apiCallReal('/browserError', () => {}, {
			error: error.stack,
			version: process.env.VERSION,
		})
		console.log('sending error info to server')
		return false
	}
}

import {checkLoggedIn, checkIfIE} from 'state/actions'
//import {initializeGa} from 'lib/helpers'

//initializeGa(window.location.hostname)
let lang = localStorage.getItem('clientLanguage')
switch(lang) {
    case 'nl':
    case 'en':
    case 'fr':
    break

    default:
        lang = 'nl'
}

window.lang = lang

dispatch(checkLoggedIn())
dispatch(checkIfIE())

const rab = makeRab(window.store)
const {isIE} = store.getState().app

const self = document.getElementById('app')

if (isIE) {
	self.setAttribute("class", "ieStyles")
}

const {mountReact, makeApp} = require('lib/helpers')
const Main = require('components/main')
const App = makeApp(Main, {onClick: e => rab.interceptClicks(e)})

mountReact(self, App, {}, true)



// WEBPACK FOOTER //
// ./lib/main.js